export default __webpack_public_path__ + "static/media/centre-map.inline.cd69f1e0.svg";